// add here other types that are required inside window object
declare global {
  interface Window {
    mapboxgl: any;
  }
}


export const arrayOrString = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  target: any,
  propertyKey: string
): void => {
  let value = target[propertyKey]

  const getter = function () {
    return value
  }

  const setter = function (newValue: unknown) {
    if (typeof newValue === 'string' || Array.isArray(newValue)) {
      value = newValue
    } else {
      console.error(`Error: "${propertyKey}" must be an array or a string.`)
    }
  }

  Object.defineProperty(target, propertyKey, {
    get: getter,
    set: setter,
    enumerable: true,
    configurable: true,
  })
}
